/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search storage records" |
*
* @param {Explorer_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_placeholder = /** @type {((inputs?: Explorer_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "de") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "it") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "es") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Search storage records")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Search storage records")
	return /** @type {LocalizedString} */ ("Search storage records")
});